function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.2 19.2C16.97 19.2 18.4 20.63 18.4 22.4C18.4 24.17 16.97 25.6 15.2 25.6C13.43 25.6 12 24.17 12 22.4C12 20.63 13.43 19.2 15.2 19.2ZM22.8 24C23.3304 24 23.8391 24.2107 24.2142 24.5858C24.5893 24.9609 24.8 25.4696 24.8 26C24.8 26.5304 24.5893 27.0391 24.2142 27.4142C23.8391 27.7893 23.3304 28 22.8 28C22.2696 28 21.7609 27.7893 21.3858 27.4142C21.0107 27.0391 20.8 26.5304 20.8 26C20.8 25.4696 21.0107 24.9609 21.3858 24.5858C21.7609 24.2107 22.2696 24 22.8 24ZM23.2 12C23.8303 12 24.4545 12.1242 25.0369 12.3654C25.6192 12.6066 26.1484 12.9602 26.5941 13.4059C27.0398 13.8516 27.3934 14.3808 27.6346 14.9631C27.8758 15.5455 28 16.1697 28 16.8C28 19.45 25.85 21.6 23.2 21.6C21.927 21.6 20.7061 21.0943 19.8059 20.1941C18.9057 19.2939 18.4 18.073 18.4 16.8C18.4 14.15 20.55 12 23.2 12Z",
  fill: "#6F62FF"
});

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.ee7f4ca9.svg";
export { ForwardRef as ReactComponent };